import { CardTemplate } from '~/editor/v2/cards/templates/types';
import { GLOBAL_PLACEHOLDER } from '~/editor/v2/cards/templates/constants';
import imageAudioCardImage from '~/assets/editor/cards4-image-audio-card.jpg';

export const imageAudioCardTemplate: CardTemplate = {
  type: 'imageAudio',
  label: 'Image + Audio Card',
  cardImage: imageAudioCardImage,

  fields: [
    {
      type: 'image',
      name: 'pictures',
      defaultValue: GLOBAL_PLACEHOLDER
    },
    {
      type: 'audio',
      name: 'audios',
      defaultValue: GLOBAL_PLACEHOLDER
    }
  ],

  createModalTitle: 'New Image + Audio Card',
  editModalTitle: 'Edit Image + Audio'
};
